import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class TextCell extends PureComponent {
    static propTypes = {
        center: PropTypes.bool,
        margin: PropTypes.number,
        right: PropTypes.bool,
        text: PropTypes.string,
    }

    static defaultProps = {
        center: false,
        margin: 0,
        right: false,
        text: '',
    }

    render() {
        const { text, right, center, margin } = this.props

        const styles = margin
            ? {
                  marginLeft: right ? 0 : margin,
                  marginRight: right ? margin : 0,
              }
            : {}

        return (
            <div className={cx('group-table-text-cell', right && 'right', center && 'center')} style={styles}>
                {text}
            </div>
        )
    }
}
